export const START_GET_GROUP_LIST = "START_GET_GROUP_LIST";
export const SUCCESS_GET_GROUP_LIST = "SUCCESS_GET_GROUP_LIST";
export const ERROR_GET_GROUP_LIST = "ERROR_GET_GROUP_LIST";

export const START_CREATE_GROUP = "START_CREATE_GROUP";
export const SUCCESS_CREATE_GROUP = "SUCCESS_CREATE_GROUP";
export const ERROR_CREATE_GROUP = "ERROR_CREATE_GROUP";

export const START_UPDATE_GROUP = "START_UPDATE_GROUP";
export const SUCCESS_UPDATE_GROUP = "SUCCESS_UPDATE_GROUP";
export const ERROR_UPDATE_GROUP = "ERROR_UPDATE_GROUP";

export const START_DELETE_GROUP = "START_DELETE_GROUP";
export const SUCCESS_DELETE_GROUP = "SUCCESS_DELETE_GROUP";
export const ERROR_DELETE_GROUP = "ERROR_DELETE_GROUP";

export const START_GET_PATIENT_FIELD_LIST = "START_GET_PATIENT_FIELD_LIST";
export const SUCCESS_GET_PATIENT_FIELD_LIST = "SUCCESS_GET_PATIENT_FIELD_LIST";
export const ERROR_GET_PATIENT_FIELD_LIST = "ERROR_GET_PATIENT_FIELD_LIST";

export const START_GET_SINGLE_GROUP = "START_GET_SINGLE_GROUP";
export const SUCCESS_GET_SINGLE_GROUP = "SUCCESS_GET_SINGLE_GROUP";
export const ERROR_GET_SINGLE_GROUP = "ERROR_GET_SINGLE_GROUP";

export const RESET_GROUP_STATE = "RESET_GROUP_STATE";

export const START_UPDATE_ORDERDATE_GROUP = "START_UPDATE_ORDERDATE_GROUP";
export const SUCCESS_UPDATE_ORDERDATE_GROUP = "SUCCESS_UPDATE_ORDERDATE_GROUP";
export const ERROR_UPDATE_ORDERDATE_GROUP = "ERROR_UPDATE_ORDERDATE_GROUP";
